const stats = [
  { value: '5+', label: 'Years Coaching' },
  { value: '200+', label: 'Clients Transformed' },
  { value: '5,000+', label: 'Training Hours' },
  { value: '100%', label: 'Results Guaranteed' },
];

export default function StatsBar() {
  return (
    <section className="bg-[#1c1917] py-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center py-4 px-4">
              <span
                className="text-[#c9a96e] mb-1"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '2rem', fontWeight: 600, lineHeight: 1 }}
              >
                {s.value}
              </span>
              <span className="text-white/50 text-[10px] tracking-[0.22em] uppercase font-sans text-center">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
